export const environment = {
  production: false,
  // apiUrl: 'https://java-spring-angular-1.preview.emergentagent.com/api'
  // apiUrl: 'https://api-continum.grubpe.com/api'
   apiUrl: 'https://stage-api.continuumnextsteps.com/api'
  //apiUrl:'http://localhost:8001/api'
};
